// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'أعد المحاولة باستخدام تاريخ كامل مثل: ' + p['dateExample'] + '.',
  chart_labelGroup: () => 'المجموعة',
  chart_labelSeries: () => 'المتوالية',
  chart_labelValue: () => 'القيمة',
  checkboxSet_requiredMessageDetail: () => 'مطلوب',
  checkbox_requiredMessageDetail: () => 'مطلوب',
  close: () => 'إغلاق',
  collection_noData: () => 'لا توجد بيانات.',
  collection_selectAllRows: () => 'تحديد كل الصفوف',
  collection_selectRow: (p: { ROW_NAME: string }) => 'تحديد الصف ' + p['ROW_NAME'],
  collection_sortDisabled: () => 'غير قابل للفرز',
  collection_sortEnabled: () => 'قابل للفرز',
  confirmation: () => 'تأكيد',
  dataVisualization_labelAndValue: (p: { LABEL: string; VALUE: string }) =>
    p['LABEL'] + ': ' + p['VALUE'],
  dataVisualization_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' من أصل ' + p['totalCount'],
  dataVisualization_noData: () => 'لا توجد بيانات',
  dataVisualization_stateSelected: () => 'محدد',
  dataVisualization_stateUnselected: () => 'غير محدد',
  error: () => 'خطأ',
  expandableList_expandCollapseInstructionText: () => 'استخدام مفاتيح الأسهم للتوسيع والطي',
  expandableList_groupCollapse: () => 'مطوي',
  expandableList_groupExpand: () => 'موسع',
  filePicker_addFiles: () => 'إضافة ملفات',
  filePicker_dropzonePrimaryText: () => 'سحب وإسقاط',
  filePicker_dropzoneSecondaryText: () => 'تحديد ملف أو إسقاط واحد هنا',
  filePicker_dropzoneSecondaryTextMultiple: () => 'تحديد الملفات أو إسقاطها هنا',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'يتعذر عليك تحميل ملفات من النوع ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'تحميل ملف واحد في كل مرة',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'يتعذر عليك تحميل ملفات من النوع ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'غير معروف',
  formControl_clear: () => 'مسح',
  formControl_day: () => 'يوم',
  formControl_helpAvailable: () => 'تتوفر التعليمات',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'لقد وصلت إلى الحد ' +
    ((
      {
        zero: new Intl.NumberFormat('ar').format(p['CHARACTER_LIMIT']) + ' حرف',
        one: '1 حرف',
        two: new Intl.NumberFormat('ar').format(p['CHARACTER_LIMIT']) + ' حرفين',
        few: new Intl.NumberFormat('ar').format(p['CHARACTER_LIMIT']) + ' أحرف',
        many: new Intl.NumberFormat('ar').format(p['CHARACTER_LIMIT']) + ' حرفًا'
      } as Partial<Record<Intl.LDMLPluralRule, string>>
    )[new Intl.PluralRules('ar').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('ar').format(p['CHARACTER_LIMIT']) + ' حرف') +
    '.',
  formControl_loading: () => 'جارٍ التحميل',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'تم تجاوز الحد الأقصى للطول ' + p['MAX_LENGTH'] + '.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'يتبقى ' + p['CHARACTER_COUNT'] + ' من الحروف.',
  formControl_month: () => 'شهر',
  formControl_readOnly: () => 'للقراءة فقط',
  formControl_requiredMessageDetail: () => 'أدخل قيمة.',
  formControl_year: () => 'سنة',
  gantt_labelDate: () => 'التاريخ',
  gantt_labelEnd: () => 'النهاية',
  gantt_labelLabel: () => 'التسمية',
  gantt_labelRow: () => 'الصف',
  gantt_labelStart: () => 'البداية',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. لم يتم العثور على مقاطع مطابقة.',
  indexer_keyboardInstructionText: () => 'اضغط على enter لتحديد قيمة.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'بين ' + p['FROM_SECTION'] + ' و' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'انقر نقرًا مزدوجًا واستمر في الضغط للدخول في وضع الإيماء، ثم اسحب لأعلى أو لأسفل لتعديل القيمة.',
  info: () => 'معلومات',
  inputDateMask_date_cleared: () => 'تاريخ التصفية',
  inputDateMask_dayPlaceholder: () => 'ي ي',
  inputDateMask_empty_segment: () => 'فارغ',
  inputDateMask_monthPlaceholder: () => 'ش ش',
  inputDateMask_yearPlaceholder: () => 'س س س س',
  inputNumber_converterParseError: () => 'أدخل رقمًا.',
  inputNumber_decrease: () => 'تقليل',
  inputNumber_increase: () => 'زيادة',
  inputPassword_hidden: () => 'تم إخفاء كلمة السر',
  inputPassword_hide: () => 'إخفاء كلمة السر',
  inputPassword_show: () => 'إظهار كلمة السر',
  list_suggestion: () => 'الاقتراح',
  messageToast_allMessagesClosed: () => 'تم إغلاق كل الرسائل المؤقتة.',
  message_close: () => 'إغلاق',
  message_confirmation: () => 'نجاح',
  message_error: () => 'خطأ',
  message_info: () => 'معلومات',
  message_navigationFromMessagesRegion: () =>
    'دخول منطقة الرسائل. اضغط على F6 للعودة إلى العنصر السابق محل التركيز.',
  message_navigationToMessagesRegion: () =>
    'تشتمل منطقة الرسائل على رسائل جديدة. اضغط على F6 للانتقال إلى منطقة أحدث الرسائل.',
  message_warning: () => 'تحذير',
  noData_message: () => 'لا توجد عناصر لعرضها',
  overflowItemLabel: () => 'المزيد من علامات التبويب',
  plural_separator: () => ', ',
  progressIndeterminate: () => 'قيد التقدم',
  radio_helpForRadio: () => 'تعليمات لزر الاختيار',
  radio_requiredMessageDetail: () => 'حدد قيمة.',
  selectMultiple_apply: () => 'تطبيق',
  selectMultiple_back: () => 'عودة',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'انقر على Backspace أو Delete لإزالة القيمة المحددة.',
  selectMultiple_selectedValues: () => 'قيم محددة',
  selectMultiple_showSelectedValues: () => 'عرض القيم المحددة فقط.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    'تم تحديد ' + p['VALUE_COUNT'] + ' من القيم.',
  select_addToList: () => 'إضافة إلى القائمة',
  select_addToListAvailable: () => 'تتوفر الإضافة إلى القائمة',
  select_moreSearchOptions: () => 'مزيد من خيارات البحث',
  select_moreSearchOptionsAvailable: () => 'تتوفر المزيد من خيارات البحث',
  select_noMatchesFound: () => 'لم يتم العثور على عناصر مطابقة.',
  select_oneMatchFound: () => 'تم العثور على عنصر مطابق واحد',
  select_requiredMessageDetail: () => 'حدد قيمة.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'تم العثور على ' + p['TOTAL_SIZE'] + ' من المطابقات',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'تم العثور على ' + p['TOTAL_SIZE'] + ' من المطابقات أو أكثر',
  selector_selected: () => 'تم تحديد مربع الاختيار',
  selector_unselected: () => 'لم يتم تحديد مربع الاختيار',
  tabBarNavigationList_removeCueText: () => 'قابل للإزالة',
  timeComponent_tooltipZoomIn: () => 'تقريب',
  timeComponent_tooltipZoomOut: () => 'إبعاد',
  train_current: () => 'الحالي',
  train_message_type: () => 'نوع الرسالة',
  train_not_visited: () => 'لم تتم الزيارة',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'الخطوة ' + p['currentStep'] + ' من أصل ' + p['numberOfSteps'],
  train_visited: () => 'تمت الزيارة',
  userAssistance_learnMore: () => 'تعرف على المزيد',
  userAssistance_required: () => 'مطلوب',
  viz_drillable: () => 'قابل للتنقل',
  warn: () => 'تحذير'
};
export default bundle;
